// https://router.vuejs.org/guide/essentials/dynamic-matching.html#catch-all-404-not-found-route
// Displays 404 page while preserving path
export function get404Route(route) {
  return {
    name: "page-not-found",
    replace: true,
    params: { pathMatch: route.path.substring(1).split("/") },
    // preserve existing query and hash if any
    query: route.query,
    hash: route.hash,
  };
}
